import React, { useState, useEffect, useRef, useContext } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { positions } from 'react-alert'
import { useAlert } from 'react-alert'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import { BASE_URLS, BASE_URL, TRACKING_CODE } from './urls';
import LoadingBar from 'react-top-loading-bar'
import ReactGA from 'react-ga';
import MetaTags from 'react-meta-tags';
import { TwitterIcon, FacebookIcon, FacebookShareButton, TwitterShareButton, WhatsappShareButton, WhatsappIcon, LinkedinShareButton, LinkedinIcon } from "react-share";
import { AppContext } from '../../user/AppContext';
import { simpleGetCallWithErrorResponse, PostCallWithErrorResponse } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import Multiselect from 'multiselect-react-dropdown';
ReactGA.initialize(TRACKING_CODE);
function BlogsDetail(props) {
    const [progress, setProgress] = useState(0)
    const [loading, setloading] = useState(true)
    const alert = useAlert()
    const [registerData, setRegisterData] = useState({ name: '', email: "", content: "", slug: '' })
    const [registerData1, setRegisterData1] = useState({ name: '', email: "", phone_no: "", message: "" })
    let [searchparams, setsearchparams] = useSearchParams()
    const [comments, setComment] = useState([])
    const [commentshow, setcommnetshow] = useState([])
    const [blog, setBlog] = useState([])
    const { slug } = useParams();
    const [latest_blogs, setlatestblogs] = useState([]);
    const width = window.innerWidth
    const { show, setShow } = useContext(AppContext);
    const [selectedata, setselecteddata] = useState([])
    const [faqdata, setFaqdata] = useState([])
    const [faqblog, setfaqblog] = useState([])
    const resetref = useRef()
    useEffect(() => {

        if (width <= 972) {
            setShow('none')
        }
        else {
            setShow('flex')
        }

    }, [])
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        ReactGA.event({
            category: 'comment section',
            action: 'visited blogdetails page'
        });
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [])
    useEffect(
        () => {
            setProgress(100)
        }, []
    )

    const handleparams = (e, slug) => {

    }

    useEffect(() => {
        const LoadBlogs = async () => {

            // const response = await fetch(`${BASE_URLS}blog?slug=${slug}`,
            //     {

            //         method: 'GET',

            //     }
            // )
            // const data = await response.json()

            // setBlog(data.Blog_Data)
            // setloading(false)

            simpleGetCallWithErrorResponse(ApiConfig.BLOG_AFTER_OPEN_DATA + `?slug=${slug}`).then((data) => {

                if (data.json.status) {
                    setBlog(data.json.Blog_Data);
                    setloading(false)
                }

            })
                .catch((error) => {
                    console.log("api response", error);
                });

        }
        simpleGetCallWithErrorResponse(ApiConfig.LATEST_FIVE_BLOG).then((data) => {

            if (data.json.status) {
                setlatestblogs(data.json.Latest_Blog);
                setProgress(true)
            }

        })
            .catch((error) => {
                console.log("api response", error);
            });

        LoadBlogs();

    }, [slug])

    function createMarkup(data) {
        return { __html: data };
    }

    useEffect(() => {

        const LoadComments = async () => {

            const response = await fetch(`${BASE_URLS}blog?slug=${slug}`,
                {
                    method: 'GET',
                }
            )
            const data = await response.json()

            setComment(data)

        }
        LoadComments()

    }, [searchparams])


    //save the comment 

    const handleCommentRegister = async (e) => {
        e.preventDefault()
        //alert.show('Thank you for your response, your comment is under review. We will display the comment shortly.', { position: positions.TOP_CENTER })
        swal({
            icon: "success",
            text: "Thank you for your response, your comment is under review !",
            button: "Close",
        });

        PostCallWithErrorResponse(ApiConfig.BLOG_SAVE_COMMENT, { ...registerData, slug: slug }).then((data) => {
            console.log(data.json)
            if (data.json.msg=='comment saved...') {
                console.log("first")
                setRegisterData({ name: "", email: "", content: "" })
                setTimeout(() => {
                    setProgress(25)
                }, 100);
                setTimeout(() => {
                    setProgress(70)
                }, 100);
                setTimeout(() => {
                    setProgress(100)
                }, 100);
            }
        })
            .catch((error) => {
                console.log("api response", error);
            });
        ReactGA.event({
            category: 'comment section',
            action: 'comment added'
        });
        // const { name, email, content, website } = e.target
        // const data = new FormData();
        // data.append('name', name.value)
        // data.append('email', email.value)
        // data.append("content", content.value)
        // data.append('slug', slug)

        // const response = await fetch(`${BASE_URLS}savecommentapi`,
        //     {
        //         method: "POST",
        //         body: data,
        //     })
        // const newdata = await response.json()
        // console.log(newdata);
        // setselecteddata([])

        // setRegisterData({ name: '', email: "", content: "" })
        // setTimeout(() => {
        //     setProgress(25)
        // }, 100);
        // setTimeout(() => {
        //     setProgress(70)
        // }, 100);
        // setTimeout(() => {
        //     setProgress(100)
        // }, 100);



    }
    const handleChange = (e) => {

        if (e.target.name === 'name') {

            setRegisterData({ ...registerData, name: e.target.value })
        }

        if (e.target.name === 'email') {

            setRegisterData({ ...registerData, email: e.target.value })
        }

        if (e.target.name === 'content') {

            setRegisterData({ ...registerData, content: e.target.value })
        }

    }

    useEffect(() => {

        const LoadComments = async () => {

            const response = await fetch(`${BASE_URLS}savecommentapi?slug=${slug}`,
                {

                    method: 'GET',
                }
            )
            const data = await response.json()
            if (data.status) {
                setcommnetshow(data.Comments_Data)
            }


        }
        LoadComments()

    }, [searchparams])

    useEffect(() => {
        const LoadFaq = async () => {

            simpleGetCallWithErrorResponse(ApiConfig.BLOG_FAQ + `?slug=${slug}`).then((data) => {
               
                if (data.json.status) {
                    setFaqdata(data.json.FAQ_Data);
                    setProgress(true)
                }
            })
                .catch((error) => {
                    console.log("api response", error);
                });


        }
        LoadFaq()
    }, [])
    //save comment end 

    //page share links start
    //  const [pageURL, setPageURL] = useState(0);
    // useEffect(() => {
    //  setPageURL(window.location.href);
    // })
    //const shareUrl = `https://prod.yourDigiWill.com/blog`;

    // sticky form data
    const handleChange1 = (e) => {

        if (e.target.name === 'first_name') {

            setRegisterData1({ ...registerData1, name: e.target.value })
        }

        if (e.target.name === 'email') {

            setRegisterData1({ ...registerData1, email: e.target.value })
        }

        if (e.target.name === 'mobile_no') {

            setRegisterData1({ ...registerData1, phone_no: e.target.value })
        }

        if (e.target.name === 'message') {

            setRegisterData1({ ...registerData1, message: e.target.value })
        }


    }

    const handleRegister1 = async (e) => {
        e.preventDefault()
        //e.target.reset();
//name,email,phone_no,message
//{name:registerData1.name,email:registerData1.email,phone_no:registerData1.phone_no,message:registerData1.message}

//...registerData1 ===name:registerData1.name,email:registerData1.email,phone_no:registerData1.phone_no,message:registerData1.message

        PostCallWithErrorResponse(ApiConfig.ENQUIRY_FORM,{...registerData1,blog_id:blog.id}
            ).then((data) => {
            console.log(data.json)
            if (data.json.status) {
                console.log("first")
                alert.show(data.json.message, { position: positions.TOP_CENTER })
                setRegisterData1({ name: '', email: "", phone_no: "", message: "" })
                
            }
        })
            .catch((error) => {
                console.log("api response", error);
            });
        ReactGA.event({
            category: 'User',
            action: 'claim-it form submitted'
        });

    }

    const servicedata = [
        {
            cat: 'Property Claims',
            key: 'Land Assets/Property ownership transfer'
        },
        {
            cat: 'Property Claims',
            key: '7/12'
        },
        {
            cat: 'Property Claims',
            key: 'Property card'
        },
        {
            cat: 'Property Claims',
            key: 'City Survey'
        },
        {
            cat: 'Property Claims',
            key: 'Varas Nondani'
        },
        {
            cat: 'Property Claims',
            key: 'Tax Receipt'
        },
        {
            cat: 'Property Claims',
            key: 'MSEB Bill Name Change.'
        },
        {
            cat: 'Property Claims',
            key: 'Water Bill Name Change'
        },

        {
            cat: 'Heir Registry',
            key: 'Heir Registry'
        },
        {
            cat: 'Investment Claims',
            key: 'Bank Investment Claims'
        },
        {
            cat: 'Investment Claims',
            key: 'Investments/savings/earnings'
        },
        {
            cat: 'Investment Claims',
            key: 'Mutual Fund Claims'
        },
        {
            cat: 'Investment Claims',
            key: 'Insurance Claims'
        },
        {
            cat: 'Investment Claims',
            key: 'Stocks/Bonds/NFTs'
        },
        {
            cat: 'Investment Claims',
            key: 'Post Office Investment Claims'
        }
    ]

    const [options] = useState(servicedata);

    const handleSelect = (selectedList, selectedItem) => {

        setselecteddata(selectedList)
    }
    function handleRemove(selectedList, selectedItem) {

        setselecteddata(selectedList)

    }

    return (
        <div>

            {/* <Popper></Popper> */}
            <MetaTags>
                <title>{blog.title}</title>
                <meta name="description" content={blog.description} />
            </MetaTags>

            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />

            {
                loading ? "" :
                    <section id="cxbd-details">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="cxbd-content cxbd-content-01">
                                        <div dangerouslySetInnerHTML={createMarkup(blog.content)}>

                                        </div>
                                        <div className='fa1-wrapper mb-3 mt-4'>
                                                 <h4 className='mb-2'>FAQ'S</h4> 
                                                {
                                                    faqdata ?
                                                    faqdata.map((FAQ_Data) => {
                                                        return (
                                                            <>
                                                                <div class="accordion accordion-flush" id="accordionFlushExample">
                                                                    <div class="accordion-item">
                                                                        <h2 class="accordion-header" id="flush-headingOne">
                                                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                                              {FAQ_Data.header}
                                                                            </button>
                                                                        </h2>
                                                                        <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                                            <div class="accordion-body"> {FAQ_Data.content} </div>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </>)

                                                    })
                                                       : <b className='text-center'>No Faq available</b> 
                                                      
                                                }

                                            </div>
                                        <hr></hr>
                                        {/* <h4>About The Author</h4>
                                        <div className='cxp-author-wrapper'>
                                            <img src={blog.author.image}></img>
                                            <div className='cxp-author' dangerouslySetInnerHTML={createMarkup(blog.author.name + "<br/>" + blog.author.bio)}>

                                            </div>

                                        </div> */}
                                        {/* <div className='cx-author-social'>
                                            <ul className="cx-social">
                                                <li><a href={blog.author.facebook_link}><i class='bx bxl-chrome'></i></a></li>
                                                <li><a href={blog.author.insta_link}><i className='bx bxl-instagram-alt' ></i></a></li>
                                                <li><a href={blog.author.twitter_link}><i className='bx bxl-twitter' ></i></a></li>
                                                <li><a href={blog.author.linkedin_link}><i className='bx bxl-linkedin-square' ></i></a></li>
                                            </ul>
                                        </div> */}

                                        {/* <div>
                                            <div className='social-heading mt-2'>
                                                <h4>Share this article on</h4>

                                            </div>
                                            <div className='social-icons-wrapper' >
                                                <ul>

                                                    <FacebookShareButton
                                                        url={shareUrl}
                                                        network="Facebook"
                                                        className="Demo__some-network__share-button"
                                                    >
                                                        <FacebookIcon size={32} round />
                                                    </FacebookShareButton>
                                                    <TwitterShareButton
                                                        url={shareUrl}
                                                        className="Demo__some-network__share-button"
                                                    >
                                                        <TwitterIcon size={32} round />
                                                    </TwitterShareButton>
                                                    <WhatsappShareButton
                                                        url={shareUrl}
                                                        separator=":: "
                                                        className="Demo__some-network__share-button"
                                                    >
                                                        <WhatsappIcon size={32} round />
                                                    </WhatsappShareButton>
                                                    <LinkedinShareButton
                                                        url={shareUrl}
                                                        network="Facebook"
                                                        className="Demo__some-network__share-button">
                                                        <LinkedinIcon size={32} round />
                                                    </LinkedinShareButton>

                                                </ul>
                                            </div>

                                        </div> */}

                                        <div className="cxbd-content-in cxbd-in2">


                                            {/* 
                                <div className="cxbd-navigation">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="cxbd-nav-left">
                                                <Link to={'/blog_detail?id=' + (blog.id +1)}><i className='bx bxs-chevron-left'></i>Previous Post</Link>

                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="cxbd-nav-right">
                                                <button type="button">Next Post <i className='bx bxs-chevron-right' ></i></button>
                                      
                                            </div>
                                        </div>
                                    </div>
                                </div> */}


                                            <div>

                                                {(comments !== {} && comments.comment) ? (comments.comment.map(
                                                    (single) => {
                                                        return (
                                                            <div key={single.slug}>
                                                                {/* <h1>{single.name}</h1>  */}

                                                                {/* 
                                                        <div className="row"> <img src="data:image/jpeg;base64,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" alt="" style={{ height: "53px", width: "59px" }} />
                                                            <div className='row'>
                                                                <h5 style={{ width: "84%", marginBottom: "2px" }}>{single.name}</h5>
                                                                <span style={{ width: "95%" }}>{single.date}</span>
                                                            </div>

                                                        </div> */}

                                                                <p>{single.content}</p>


                                                                {/* {(single.reply.length !== 0) ? (
                                                                    single.reply.map((rsingle) => {
                                                                        return (
                                                                            <h3 style={{ marginLeft: "100px" }}>{rsingle.rname}</h3>
                                                                        )
                                                                    })
                                                                ) : (console.log("hello"))} */}
                                                            </div>

                                                        )
                                                    }

                                                )) : (console.log("hello"))
                                                }

                                            </div>

                                            <div className="cxbd-reply">
                                                <h4>Leave a Reply</h4>
                                                <form onSubmit={(e) => { handleCommentRegister(e) }}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <input name='name' required type="text" value={registerData.name} onChange={(e) => handleChange(e)} className="form-control" placeholder="Name*" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <input name='email' required type="email" value={registerData.email} onChange={(e) => handleChange(e)} className="form-control" placeholder="Email*" />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mb-3">
                                                                <textarea rows="2" required name='content' value={registerData.content} onChange={(e) => handleChange(e)} className="form-control" placeholder="Your comment here..."></textarea>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12" style={{ textAlign: "right" }}>
                                                            <button type="submit" className="cx-btn">Comment</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                           
                                            <div className='mt-5'>
                                                {/* <h4 className='mb-2'>Comments</h4> */}
                                                <div className='comments-wrapper align-items-center'>


                                                    {
                                                        commentshow ?
                                                            <b className='text-center'></b> : commentshow.map((Comments_Data) => {
                                                                return (
                                                                    <>
                                                                        <div className=' comment-main-wrapper d-flex align-items-center flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-1 border-bottom'>

                                                                            <div className='comments-naming-wrapper'>
                                                                                <h4>{Comments_Data.name}</h4>
                                                                                <p className='mb-2'>{Comments_Data.content}</p>
                                                                                <p className='text-muted'>{Comments_Data.date}</p>
                                                                            </div>

                                                                        </div>

                                                                    </>)

                                                            })
                                                    }



                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="cxbd-content">
                                        <div className="cx-form-group">
                                            <input type="text" className="form-control" aria-describedby="emailHelp" placeholder="Search" />
                                            <div className="cxbd-title">
                                                <h6>Recent Posts</h6>
                                            </div>
                                            <ul className="cxbd-post-list">

                                                {
                                                    latest_blogs.map((single) => {
                                                        return (

                                                            //  <li key={single.title}><a href='#' onClick={(e) => handleparams(e, single.slug)}>{single.title}</a></li>
                                                            <li><Link to={"/blog/" + single.slug}><a
                                                                dangerouslySetInnerHTML={createMarkup(single.title)}
                                                            /></Link></li>

                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="cxbd-content text-center" >
                                        <div className="cx-form-group">
                                            <div className="cxbd-title">
                                                <h4>Download App</h4>
                                            </div>
                                            <ul className="cxbd-post-list">

                                            
                                            <div >
                                        <a href="https://play.google.com/store/apps/details?id=com.app.yourdigiwillapp" target="_blank" className="cx-banner-btns"><img src="https://websiteimagesdigiwill.s3.ap-south-1.amazonaws.com/google-play-badge.png"  style={{ height: "65.79px", width: "170px" }} alt="DigiWill App - Get it on Google Play Store" /></a>
                                            {/*    <a href="#"><img src="images/home/app_store.png" /></a> */}
                                        
                    
                                        </div>
                                                     
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="sticky-top ">
                                        <div className='moredetails_form '>
                                            <form onSubmit={(e) => handleRegister1(e)} >
                                                <div className='service_cart_form undefined card'>
                                                    <div className='card-body'>
                                                        <div className='card-title h5 mb-4'>
                                                            <b>Enquiry Form</b>
                                                        </div>
                                                        <div className='row'>
                                                            <div class="mb-3 ">

                                                                <input type="name" required value={registerData1.name} onChange={(e) => handleChange1(e)} name='first_name' class="form-control" id="exampleFormControlInput1" placeholder="Full Name" />
                                                            </div>
                                                            <div class="mb-3 ">

                                                                <input type="email" required value={registerData1.email} onChange={(e) => handleChange1(e)} name='email' class="form-control" id="exampleFormControlInput1" placeholder="Email " />
                                                            </div>
                                                            <div class="mb-3 ">

                                                                <input type="tel" required value={registerData1.phone_no} onChange={(e) => handleChange1(e)} name='mobile_no' class="form-control" id="exampleFormControlInput1" placeholder="Phone No" />
                                                            </div>
                                                            <div className="mb-3 " >
                                                                <input type="name" maxlength="120" required value={registerData1.message} onChange={(e) => handleChange1(e)} name='message' class="form-control message-field" id="exampleFormControlInput1" placeholder="message" />
                                                            </div>
                                                            <div>

                                                            </div>
                                                            <div class="serviceaction">
                                                                <button id="secondary_lead_submit" type="submit" class="font-weight-bold undefined btn btn-primary">Talk to an Expert</button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
            }





        </div>

    )
}

export default BlogsDetail;
